module.exports = __webpack_public_path__ + "img/back_icon.fe52e5a2.png";